import {
  BANK_DETAILS_SUCCESS,
  CLEAR_STORE,
  ASYNC_VALIDATION_RESPONSE,
  CARD_NUMBER_UPDATED
} from '../../action-contants';

const INITIAL_STATE = {
  show_loader: false,
  asyncResponse: {
    fastFundsIndicator: null
  },
  cardUpdated: false
};

export default function bankValidationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    case BANK_DETAILS_SUCCESS:
      return { ...state, ...action.data };
    case ASYNC_VALIDATION_RESPONSE:
      return { ...state, asyncResponse: { ...action.data } };
    case CARD_NUMBER_UPDATED:
      return { ...state, cardUpdated: action.value };
    default:
      return state;
  }
}
